import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import SideBar from "../../SideBar";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { FaCashRegister, FaRegTrashAlt, FaRegEdit } from "react-icons/fa";
import HeaderName from "../../HeaderName";
import { useSelector } from "react-redux";
import { api } from "../../../../api/api";

function SubCategory() {


    const [categoryLists, setCategoryLists] = useState([]);
    const [pointList, setPointList] = useState([]);
    const [currency, setCurrency] = useState("");
    const [point, setPoint] = useState("");
    const [type, setType] = useState("");
    const [amount, setAmount] = useState("");
    const [description, setDescription] = useState('');
    const [showUpdate, setShowUpdate] = useState(false);
    const [updateDataList, setUpdateDataList] = useState([]);
    const [upCode, setUpCode] = useState("");
    const [upName, setUpName] = useState("");
    const [upDesc, setUpDesc] = useState("");
    const [relatedCat, setRelatedCat] = useState("");
    const [relatedCatID, setRelatedCatID] = useState("");
    const [Id, setId] = useState("");
    const navigate = useNavigate();

    // const [categoryLists, setCategoryLists] = useState([]);

    const handleDelete = async (id) => {
        if (!id) {
            console.error('Invalid ID');
            return
        }
        console.log('point with ID:', id)

        try {
            await api.delete(`point/${id}`)
            Swal.fire({
                title: 'Deleted!',
                text: 'The treatment has been deleted successfully.',
                icon: 'success',
                showConfirmButton: false,
                timer: 2000
            })
            console.log("success")

            setPointList(prev => prev.filter(item => item._id !== id))

        } catch (error) {
            console.error('Delete Error:', error)
            Swal.fire({
                title: 'Error!',
                text: error.response?.data?.message || 'Something went wrong.',
                icon: 'error',
                showConfirmButton: false,
                timer: 2000
            })
        }
    }

    const handleUpdate = (event) => {
        // console.log(event, 'event')
        const getCatUpdate = async () => {
            try {
                const res = await api.get("point/" + event);
                console.log(res.data.data, 'event')
                setPoint(res.data.data.point);
                setType(res.data.data.type);
                setAmount(res.data.data.amount);
                setDescription(res.data.data.description);
            } catch (err) { }
        };
        getCatUpdate();
        setShowUpdate(true);
        setId(event);
    };

    const Update = () => {
        const data = {
            type: type,
            point: point,
            amount: amount,
            currency: currency,
            description: description,
        };

        const config = {
            headers: { "Content-Type": "application/json" },
        };
        api
            .put("point/" + Id, data, config)
            .then(function (response) {
                Swal.fire({
                    title: "Successful!",
                    text: "You Updated Data!",
                    icon: "success",
                    showConfirmButton: false,
                    timer: 3000
                });


                //  setSubCategoryLists([...subCategoryLists, response.data.data]);
                setPointList(
                    pointList.map((category) => {
                        if (category._id === response.data.data._id) {
                            return response.data.data;
                        } else {
                            return category;
                        }
                    })
                );
            })
            .catch(function (err) {
                Swal.fire({
                    title: "Something Wrong!",
                    text: "Try again, Please.",
                    icon: "warning",
                    // showCancelButton: true,

                    cancelButtonText: "Close",
                });
            });
        document.getElementById("desc").value = "";
        document.getElementById("name").value = "";
        document.getElementById("code").value = "";
        document.getElementById("cat").value = "";
    };

    const Create = () => {
        if (!type || !point || !amount || !currency || !description) {
            Swal.fire({
                title: "Missing Data!",
                text: "Please fill in all the fields.",
                icon: "warning",
                showConfirmButton: false,
                timer: 3000
            });
            return;
        }
        const data = {
            type: type,
            point: point,
            amount: amount,
            currency: currency,
            description: description,
        };

        // alert(JSON.stringify(data));

        const config = {
            headers: { "Content-Type": "application/json" },
        };
        api
            .post("point", data, config)
            .then(function (response) {
                Swal.fire({
                    title: "Successful!",
                    text: "You Created Data!",
                    icon: "success",
                    showConfirmButton: false,
                    timer: 3000
                });


                setPointList([...pointList, response.data.data]);
            })
            .catch(function (err) {
                Swal.fire({
                    title: "Something Wrong!",
                    text: "Try again, Please.",
                    icon: "warning",
                    showCancelButton: false,
                    timer: 3000

                });
            });
        document.getElementById("desc").value = "";
        document.getElementById("name").value = "";
        document.getElementById("code").value = "";
        document.getElementById("cat").value = "";
    };
    useEffect(() => {

        const getSubCategory = async () => {
            try {
                const res = await api.get("points");

                console.log(res.data.pointRules, "sub cat");
                setPointList(res.data.pointRules);
            } catch (err) { }
        };

        getSubCategory();
    }, []);
    return (
      <>
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-12">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item active fs-5">
                    Point Rules List
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- Main content --> */}

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-9">
                <div className="card">
                  <div className="card-header">
                    {/* <h3 className="card-title">Cost Center List</h3> */}
                  </div>
                  <div className="card-body">
                    <table id="example1" className="table">
                      <thead className=" bg-info">
                        <tr>
                          <th>No</th>
                          <th>Type</th>
                          <th>Amount Per Point</th>
                          <th>Point</th>
                          <th>Last Updated</th>
                          <th>Description</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      {pointList &&
                        pointList.map((cat, i) => (
                          <tbody className="" key={i}>
                            <tr>
                              <td>{++i}</td>
                              <td>{cat.type}</td>
                              <td>{cat.amount}</td>
                              <td>{cat.point}</td>
                              <td>{cat.date?.split("T")[0]}</td>
                              <td>{cat.description}</td>
                              <td>
                                <button
                                  className="btn btn-sm btn-warning"
                                  onClick={(e) => handleUpdate(cat._id)}
                                >
                                  <FaRegEdit />
                                </button>
                                &nbsp;
                                <button
                                  className="btn btn-sm btn-danger"
                                  onClick={(e) => handleDelete(cat._id)}
                                >
                                  <FaRegTrashAlt />
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        ))}
                    </table>
                  </div>
                </div>
              </div>

              {showUpdate ? (
                <div className="col-md-3">
                  <div className="card">
                    <h5 className="card-header mb-4 fw-5 text-secondary py-3">
                      Update Point Rule
                    </h5>
                    <div className="px-3 py-3">
                      <div className="form-group">
                        <label htmlFor="name">Type</label>
                        <select
                          className="custom-select border-info"
                          name="account_type_id"
                          value={type}
                          id="cat"
                          onChange={(e) => setType(e.target.value)}
                        >
                          {/* <option value={type} hidden>{type}</option> */}

                          <option value="Aesthetic">Aesthetic</option>
                          <option value="Surgery">Surgery</option>
                          <option value="Pharmacy">Pharmacy</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor="currency">Select Currency</label>
                        <select
                          className="custom-select border-info"
                          name="currency"
                          value={currency}
                          id="cat"
                          onChange={(e) => setCurrency(e.target.value)}
                        >
                          <option hidden>Choose Currency</option>
                          <option value="usd">USD</option>
                          <option value="mmk">MMK</option>
                          <option value="bath">THB</option>
                          <option value="ringgit">MYR</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor="code" className="text-secondary">
                          Point
                        </label>
                        <input
                          type="number"
                          className="form-control border-info"
                          name="code"
                          id="code"
                          value={point}
                          //   ref={(el) => (this.name = el)}
                          onChange={(e) => setPoint(e.target.value)}
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="name" className="text-secondary">
                          Amount Per Point
                        </label>
                        <input
                          type="number"
                          className="form-control border-info"
                          name="balance"
                          id="name"
                          value={amount}
                          //   ref={(el) => (this.name = el)}
                          onChange={(e) => setAmount(e.target.value)}
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="name" className="text-secondary">
                          Description
                        </label>
                        <textarea
                          className="form-control"
                          id="desc"
                          value={description}
                          //   ref={(el) => (this.description = el)}
                          onChange={(e) => setDescription(e.target.value)}
                        ></textarea>
                      </div>
                      <button
                        style={{ backgroundColor: "#0b9490", color: "white" }}
                        className="btn  form-control text-center fw-5"
                        onClick={Update}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="col-md-3">
                  <div className="card">
                    <h5 className="card-header mb-4 fw-5 text-secondary py-3">
                      Create Point Rule
                    </h5>
                    <div className="px-3 py-3">
                      <div className="form-group">
                        <label htmlFor="name">Type</label>
                        <select
                          className="custom-select border-info"
                          name="account_type_id"
                          id="cat"
                          onChange={(e) => setType(e.target.value)}
                        >
                          <option hidden>Choose Category</option>
                          <option value="Aesthetic">Aesthetic</option>
                          <option value="Surgery">Surgery</option>
                          <option value="Pharmacy">Pharmacy</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor="currency">Select Currency</label>
                        <select
                          className="custom-select border-info"
                          name="currency"
                          value={currency}
                          id="cat"
                          onChange={(e) => setCurrency(e.target.value)}
                        >
                          <option hidden>Choose Currency</option>
                          <option value="usd">USD</option>
                          <option value="mmk">MMK</option>
                          <option value="bath">THB</option>
                          <option value="ringgit">MYR</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor="code" className="text-secondary">
                          Point
                        </label>
                        <input
                          type="number"
                          className="form-control border-info"
                          name="code"
                          id="code"
                          //   ref={(el) => (this.name = el)}
                          onChange={(e) => setPoint(e.target.value)}
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="name" className="text-secondary">
                          Amount Per Point
                        </label>
                        <input
                          type="number"
                          className="form-control border-info"
                          name="balance"
                          id="name"
                          //   ref={(el) => (this.name = el)}
                          onChange={(e) => setAmount(e.target.value)}
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="name" className="text-secondary">
                          Description
                        </label>
                        <textarea
                          className="form-control"
                          id="desc"
                          //   ref={(el) => (this.description = el)}
                          onChange={(e) => setDescription(e.target.value)}
                        ></textarea>
                      </div>
                      <button
                        style={{ backgroundColor: "#0b9490", color: "white" }}
                        className="btn  form-control text-center fw-5"
                        onClick={Create}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          {/*<!-- /.container-fluid --> */}
        </section>
      </>
    );
}
export default SubCategory;
